import { render, staticRenderFns } from "./add.vue?vue&type=template&id=5babd0a0&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=5babd0a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babd0a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5babd0a0')) {
      api.createRecord('5babd0a0', component.options)
    } else {
      api.reload('5babd0a0', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=5babd0a0&scoped=true", function () {
      api.rerender('5babd0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suggestion/add.vue"
export default component.exports